import React, { useEffect } from "react";

const TokenSender = () => {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin === "http://192.168.18.77:4000") {
        const token =
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvcG9ydGFsLmZhbWV3aGVlbHMuY29tXC9sb2dpbiIsImlhdCI6MTcxNzA1NDMzNiwiZXhwIjoxNzQ4NTkwMzM2LCJuYmYiOjE3MTcwNTQzMzYsImp0aSI6IkQ4UGNGN0VQUDBraTZrZHQiLCJzdWIiOjM1LCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.3w8GGFlzl300lmWy0tJ5QFhgHZhYRDGD6JWPCOGyC0k";
        event.source.postMessage(token, event.origin);
        console.log(`Token sent to ${event.origin}: ${token}`);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
      <h1>hello i am working</h1>
    </>
  );
};

export default TokenSender;
